module.exports = __webpack_public_path__ + "static/media/cross-red.0cca4d28.svg";